module.exports = __webpack_public_path__ + "img/logo-10.2136cc68.png";